export const CARDS_DATA = [
  {
    src: '/lp/common/app-store.webp',
    alt: 'app-store',
    width: 111,
  },
  {
    src: '/lp/common/google-play.webp',
    alt: 'google-play',
    width: 111,
  },
  {
    src: '/lp/common/mastercard.webp',
    alt: 'mastercard',
    width: 57,
  },
  {
    src: '/lp/common/visa.webp',
    alt: 'visa',
    width: 57,
  },
];
